"use strict";

var _this = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Implements ES5 [`Array#forEach()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach) method.<br><br>
 * Executes the provided callback once for each element.<br>
 * Callbacks are run concurrently,
 * and are only invoked for properties of the array that have been initialized (including those initialized with *undefined*), for unassigned ones `callback` is not run.<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with undefined value.
 */
exports.forEach =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(array, callback, thisArg) {
    var promiseArray, _loop, i;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promiseArray = [];

            _loop = function _loop(i) {
              if (i in array) {
                var p = Promise.resolve(array[i]).then(function (currentValue) {
                  return callback.call(thisArg || _this, currentValue, i, array);
                });
                promiseArray.push(p);
              }
            };

            for (i = 0; i < array.length; i++) {
              _loop(i);
            }

            _context.next = 5;
            return Promise.all(promiseArray);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Same functionality as [`forEach()`](global.html#forEach), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with undefined value.
 */


exports.forEachSeries =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context2.next = 15;
              break;
            }

            if (!(i in array)) {
              _context2.next = 12;
              break;
            }

            _context2.t0 = callback;
            _context2.t1 = thisArg || _this;
            _context2.next = 7;
            return array[i];

          case 7:
            _context2.t2 = _context2.sent;
            _context2.t3 = i;
            _context2.t4 = array;
            _context2.next = 12;
            return _context2.t0.call.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3, _context2.t4);

          case 12:
            i++;
            _context2.next = 1;
            break;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#map()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map) method.<br><br>
 * Creates a new array with the results of calling the provided callback once for each element.<br>
 * Callbacks are run concurrently,
 * and are only invoked for properties of the array that have been initialized (including those initialized with *undefined*), for unassigned ones`callback` is not run.<br>
 * Resultant *Array* is always the same *length* as the original one.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant *Array* as value.
 */


exports.map =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(array, callback, thisArg) {
    var promiseArray, _loop2, i;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            promiseArray = [];

            _loop2 = function _loop2(i) {
              if (i in array) {
                promiseArray[i] = Promise.resolve(array[i]).then(function (currentValue) {
                  return callback.call(thisArg || _this, currentValue, i, array);
                });
              }
            };

            for (i = 0; i < array.length; i++) {
              _loop2(i);
            }

            return _context3.abrupt("return", Promise.all(promiseArray));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Same functionality as [`map()`](global.html#map), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant *Array* as value.
 */


exports.mapSeries =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(array, callback, thisArg) {
    var result, i;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            result = [];
            i = 0;

          case 2:
            if (!(i < array.length)) {
              _context4.next = 17;
              break;
            }

            if (!(i in array)) {
              _context4.next = 14;
              break;
            }

            _context4.t0 = callback;
            _context4.t1 = thisArg || _this;
            _context4.next = 8;
            return array[i];

          case 8:
            _context4.t2 = _context4.sent;
            _context4.t3 = i;
            _context4.t4 = array;
            _context4.next = 13;
            return _context4.t0.call.call(_context4.t0, _context4.t1, _context4.t2, _context4.t3, _context4.t4);

          case 13:
            result[i] = _context4.sent;

          case 14:
            i++;
            _context4.next = 2;
            break;

          case 17:
            return _context4.abrupt("return", result);

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#find()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find) method.<br><br>
 * Returns the value of the element that satisfies the provided `callback`. The value returned is the one found first.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if the returned value is found in one of the first elements of `array`,
 * depending on the async calls you are going to use, consider using instead [`findSeries()`](global.html#findSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the element that passed the test as value, otherwise *undefined*.
 */


exports.find = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve();
    }

    var counter = 1;

    var _loop3 = function _loop3(i) {
      var check = function check(found) {
        if (found) {
          resolve(array[i]);
        } else if (counter === array.length) {
          resolve();
        }

        counter++;
      };

      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check)["catch"](reject);
    };

    for (var i = 0; i < array.length; i++) {
      _loop3(i);
    }
  });
};
/**
 * Same functionality as [`find()`](global.html#find), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the element that passed the test as value, otherwise *undefined*.
 */


exports.findSeries =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context5.next = 16;
              break;
            }

            _context5.t0 = callback;
            _context5.t1 = thisArg || _this;
            _context5.next = 6;
            return array[i];

          case 6:
            _context5.t2 = _context5.sent;
            _context5.t3 = i;
            _context5.t4 = array;
            _context5.next = 11;
            return _context5.t0.call.call(_context5.t0, _context5.t1, _context5.t2, _context5.t3, _context5.t4);

          case 11:
            if (!_context5.sent) {
              _context5.next = 13;
              break;
            }

            return _context5.abrupt("return", array[i]);

          case 13:
            i++;
            _context5.next = 1;
            break;

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x13, _x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#findIndex()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex) method.<br><br>
 * Returns the index of the element that satisfies the provided `callback`. The index returned is the one found first.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if the returned index is found in one of the first elements of `array`,
 * depending on the async calls you are going to use, consider using instead [`findSeries()`](global.html#findSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the index that passed the test as value, otherwise *-1*.
 */


exports.findIndex = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(-1);
    }

    var counter = 1;

    var _loop4 = function _loop4(i) {
      var check = function check(found) {
        if (found) {
          resolve(i);
        } else if (counter === array.length) {
          resolve(-1);
        }

        counter++;
      };

      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check)["catch"](reject);
    };

    for (var i = 0; i < array.length; i++) {
      _loop4(i);
    }
  });
};
/**
 * Same functionality as [`findIndex()`](global.html#findIndex), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the index that passed the test, otherwise *-1*.
 */


exports.findIndexSeries =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context6.next = 16;
              break;
            }

            _context6.t0 = callback;
            _context6.t1 = thisArg || _this;
            _context6.next = 6;
            return array[i];

          case 6:
            _context6.t2 = _context6.sent;
            _context6.t3 = i;
            _context6.t4 = array;
            _context6.next = 11;
            return _context6.t0.call.call(_context6.t0, _context6.t1, _context6.t2, _context6.t3, _context6.t4);

          case 11:
            if (!_context6.sent) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt("return", i);

          case 13:
            i++;
            _context6.next = 1;
            break;

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x16, _x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#some()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some) method.<br><br>
 * Test if some element in `array` passes the test implemented in `callback`.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if some of the first elements pass the test,
 * depending on the async calls you are going to use, consider using instead [`someSeries()`](global.html#someSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if some element passed the test, otherwise *false*.
 */


exports.some = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(false);
    }

    var counter = 1;

    var _loop5 = function _loop5(i) {
      if (!(i in array)) {
        counter++;
        return "continue";
      }

      var check = function check(found) {
        if (found) {
          resolve(true);
        } else if (counter === array.length) {
          resolve(false);
        }

        counter++;
      };

      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check)["catch"](reject);
    };

    for (var i = 0; i < array.length; i++) {
      var _ret = _loop5(i);

      if (_ret === "continue") continue;
    }
  });
};
/**
 * Same functionality as [`some()`](global.html#some), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if some element passed the test, otherwise *false*.
 */


exports.someSeries =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee7(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context7.next = 19;
              break;
            }

            _context7.t0 = i in array;

            if (!_context7.t0) {
              _context7.next = 14;
              break;
            }

            _context7.t1 = callback;
            _context7.t2 = thisArg || _this;
            _context7.next = 8;
            return array[i];

          case 8:
            _context7.t3 = _context7.sent;
            _context7.t4 = i;
            _context7.t5 = array;
            _context7.next = 13;
            return _context7.t1.call.call(_context7.t1, _context7.t2, _context7.t3, _context7.t4, _context7.t5);

          case 13:
            _context7.t0 = _context7.sent;

          case 14:
            if (!_context7.t0) {
              _context7.next = 16;
              break;
            }

            return _context7.abrupt("return", true);

          case 16:
            i++;
            _context7.next = 1;
            break;

          case 19:
            return _context7.abrupt("return", false);

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x19, _x20, _x21) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#every()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every) method.<br><br>
 * Test if all elements in `array` pass the test implemented in `callback`.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if any of the first elements do not pass the test,
 * depending on the async calls you are going to use, consider using instead [`everySeries()`](global.html#everySeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if all elements passed the test, otherwise *false*.
 */


exports.every = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(true);
    }

    var counter = 1;

    var _loop6 = function _loop6(i) {
      if (!(i in array)) {
        counter++;
        return "continue";
      }

      var check = function check(found) {
        if (!found) {
          resolve(false);
        } else if (counter === array.length) {
          resolve(true);
        }

        counter++;
      };

      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check)["catch"](reject);
    };

    for (var i = 0; i < array.length; i++) {
      var _ret2 = _loop6(i);

      if (_ret2 === "continue") continue;
    }
  });
};
/**
 * Same functionality as [`every()`](global.html#every), but runs only one callback at a time.<br><br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if all elements passed the test, otherwise *false*.
 */


exports.everySeries =
/*#__PURE__*/
function () {
  var _ref8 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee8(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context8.next = 19;
              break;
            }

            _context8.t0 = i in array;

            if (!_context8.t0) {
              _context8.next = 14;
              break;
            }

            _context8.t1 = callback;
            _context8.t2 = thisArg || _this;
            _context8.next = 8;
            return array[i];

          case 8:
            _context8.t3 = _context8.sent;
            _context8.t4 = i;
            _context8.t5 = array;
            _context8.next = 13;
            return _context8.t1.call.call(_context8.t1, _context8.t2, _context8.t3, _context8.t4, _context8.t5);

          case 13:
            _context8.t0 = !_context8.sent;

          case 14:
            if (!_context8.t0) {
              _context8.next = 16;
              break;
            }

            return _context8.abrupt("return", false);

          case 16:
            i++;
            _context8.next = 1;
            break;

          case 19:
            return _context8.abrupt("return", true);

          case 20:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function (_x22, _x23, _x24) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#filter()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter) method.<br><br>
 * Creates a new array with the elements that passed the test implemented in `callback`.<br>
 * Callbacks are run concurrently.<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant filtered *Array* as value.
 */


exports.filter = function (array, callback, thisArg) {
  /* two loops are necessary in order to do the filtering concurrently
   * while keeping the order of the elements
   * (if you find a better way to do it please send a PR!)
   */
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref9 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(resolve, reject) {
      var promiseArray, _loop7, i, filteredArray;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              promiseArray = [];

              _loop7 = function _loop7(i) {
                if (i in array) {
                  promiseArray[i] = Promise.resolve(array[i]).then(function (currentValue) {
                    return callback.call(thisArg || _this, currentValue, i, array);
                  })["catch"](reject);
                }
              };

              for (i = 0; i < array.length; i++) {
                _loop7(i);
              }

              filteredArray = [];
              i = 0;

            case 5:
              if (!(i < promiseArray.length)) {
                _context9.next = 17;
                break;
              }

              _context9.next = 8;
              return promiseArray[i];

            case 8:
              if (!_context9.sent) {
                _context9.next = 14;
                break;
              }

              _context9.t0 = filteredArray;
              _context9.next = 12;
              return array[i];

            case 12:
              _context9.t1 = _context9.sent;

              _context9.t0.push.call(_context9.t0, _context9.t1);

            case 14:
              i++;
              _context9.next = 5;
              break;

            case 17:
              resolve(filteredArray);

            case 18:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x25, _x26) {
      return _ref9.apply(this, arguments);
    };
  }());
};
/**
 * Same functionality as [`filter()`](global.html#filter), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @return {Promise} - Returns a Promise with the resultant filtered *Array* as value.
 */


exports.filterSeries =
/*#__PURE__*/
function () {
  var _ref10 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee10(array, callback, thisArg) {
    var result, i;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            result = [];
            i = 0;

          case 2:
            if (!(i < array.length)) {
              _context10.next = 24;
              break;
            }

            _context10.t0 = i in array;

            if (!_context10.t0) {
              _context10.next = 15;
              break;
            }

            _context10.t1 = callback;
            _context10.t2 = thisArg || _this;
            _context10.next = 9;
            return array[i];

          case 9:
            _context10.t3 = _context10.sent;
            _context10.t4 = i;
            _context10.t5 = array;
            _context10.next = 14;
            return _context10.t1.call.call(_context10.t1, _context10.t2, _context10.t3, _context10.t4, _context10.t5);

          case 14:
            _context10.t0 = _context10.sent;

          case 15:
            if (!_context10.t0) {
              _context10.next = 21;
              break;
            }

            _context10.t6 = result;
            _context10.next = 19;
            return array[i];

          case 19:
            _context10.t7 = _context10.sent;

            _context10.t6.push.call(_context10.t6, _context10.t7);

          case 21:
            i++;
            _context10.next = 2;
            break;

          case 24:
            return _context10.abrupt("return", result);

          case 25:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function (_x27, _x28, _x29) {
    return _ref10.apply(this, arguments);
  };
}();
/**
 * Implements ES5 [`Array#reduce()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce) method.<br><br>
 * Applies a `callback` against an accumulator and each element in `array`.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts four arguments: `accumulator`, `currentValue`, `currentIndex` and `array`.
 * @param {Object} [initialValue] - Used as first argument to the first call of `callback`.
 * @return {Promise} - Returns a Promise with the resultant value from the reduction.
 */


exports.reduce =
/*#__PURE__*/
function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee11(array, callback, initialValue) {
    var i, previousValue;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(array.length === 0 && initialValue === undefined)) {
              _context11.next = 2;
              break;
            }

            throw TypeError('Reduce of empty array with no initial value');

          case 2:
            if (initialValue !== undefined) {
              previousValue = initialValue;
              i = 0;
            } else {
              previousValue = array[0];
              i = 1;
            }

            i;

          case 4:
            if (!(i < array.length)) {
              _context11.next = 21;
              break;
            }

            if (!(i in array)) {
              _context11.next = 18;
              break;
            }

            _context11.t0 = callback;
            _context11.next = 9;
            return previousValue;

          case 9:
            _context11.t1 = _context11.sent;
            _context11.next = 12;
            return array[i];

          case 12:
            _context11.t2 = _context11.sent;
            _context11.t3 = i;
            _context11.t4 = array;
            _context11.next = 17;
            return (0, _context11.t0)(_context11.t1, _context11.t2, _context11.t3, _context11.t4);

          case 17:
            previousValue = _context11.sent;

          case 18:
            i++;
            _context11.next = 4;
            break;

          case 21:
            return _context11.abrupt("return", previousValue);

          case 22:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function (_x30, _x31, _x32) {
    return _ref11.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/p-iteration/lib/static-methods.js
// module id = 202
// module chunks = 0